import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { CountdownTypesEnum } from 'common/components/entities/Countdown/enums/CountdownTypesEnum'
import { CountdownInterface } from 'common/types/entities/CountdownInterface'
import React from 'react'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'

interface CountdownDelayProps {
  entity: CountdownInterface
}

const CountdownDelay = ({ entity }: CountdownDelayProps) => {
  const updateProp = useUpdateProp(entity)

  const updateDelay =
    (delayKey: keyof CountdownInterface['delay']) => (value: number) => {
      return updateProp(CountdownTypesEnum.delay)({
        ...entity[CountdownTypesEnum.delay],
        [delayKey]: value,
        createdAt: new Date().getTime(),
      })
    }

  return (
    <>
      <RangeElement
        label={'entity_settings.countdown.delay.days'}
        value={entity[CountdownTypesEnum.delay].days}
        onChange={updateDelay('days')}
        max={99}
      />
      <RangeElement
        label="entity_settings.countdown.delay.hours"
        value={entity[CountdownTypesEnum.delay].hours}
        onChange={updateDelay('hours')}
        max={23}
      />
      <RangeElement
        label="entity_settings.countdown.delay.minutes"
        value={entity[CountdownTypesEnum.delay].minutes}
        onChange={updateDelay('minutes')}
        min={0}
        max={59}
      />
      <RangeElement
        label="entity_settings.countdown.delay.seconds"
        value={entity[CountdownTypesEnum.delay].seconds}
        onChange={updateDelay('seconds')}
        min={0}
        max={59}
      />
    </>
  )
}

export default CountdownDelay
